import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  HEADER_ACADEMY_LOGO_ALT,
  HEADER_ACADEMY_LOGO_SOURCES,
  getNextHeaderLogoSource,
} from "../constants/headerBrandAssets";

/**
 * Shared academy logo for private headers (student, instructor, director/admin).
 * Falls back through static and CDN sources when an asset is missing.
 */
function HeaderBrandLogo({ linkTo, className, alt }) {
  const [src, setSrc] = useState(HEADER_ACADEMY_LOGO_SOURCES[0]);

  const handleError = useCallback(() => {
    setSrc((current) => getNextHeaderLogoSource(current) ?? current);
  }, []);

  if (typeof linkTo === "string" && linkTo.length > 0) {
    return (
      <Link to={linkTo} aria-label={alt}>
        <img
          src={src}
          alt=""
          className={className}
          draggable="false"
          onContextMenu={(e) => e.preventDefault()}
          onError={handleError}
        />
      </Link>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      draggable="false"
      onContextMenu={(e) => e.preventDefault()}
      onError={handleError}
    />
  );
}

HeaderBrandLogo.propTypes = {
  linkTo: PropTypes.string,
  className: PropTypes.string,
  alt: PropTypes.string,
};

HeaderBrandLogo.defaultProps = {
  linkTo: undefined,
  className: "header-brand-logo ui-integrated-image",
  alt: HEADER_ACADEMY_LOGO_ALT,
};

export default HeaderBrandLogo;
